import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const ModalRecomendacionSoftware = ({ open, onClose }) => {
    const softwareData = [
        {
            software: "Adobe Reader",
            procesador: "1.5 GHz o más rápido",
            ram: "8 GB",
            espacio: "380 MB",
            tarjetaVideo: "No es necesaria",
            recomendaciones: "Usa gráficos integrados; solo maneja documentos PDF sin renderizado complejo.",
            modelos: ""
        },
        {
            software: "Autodesk (AutoCAD)",
            procesador: "3.0 GHz o más rápido",
            ram: "8 GB (mín.) 16 GB (recom.)",
            espacio: "6 GB",
            tarjetaVideo: "Sí, recomendada para diseño en 3D",
            recomendaciones: "NVIDIA Quadro o AMD FirePro; mejora la fluidez en modelado 3D y renderizado.",
            modelos: "NVIDIA Quadro RTX A2000 / A4000 AMD Radeon Pro W6600 / W6800 NVIDIA GeForce RTX 4060 / 4070"
        },
        {
            software: "SAP2000",
            procesador: "2.5 GHz o más rápido (64 bits)",
            ram: "8 GB (mín.) 16 GB (recom.)",
            espacio: "6 GB + proyectos",
            tarjetaVideo: "Sí, recomendada para análisis gráfico avanzado",
            recomendaciones: "Tarjeta con OpenGL 4.5 o superior; mejora el modelado estructural y la simulación de cargas.",
            modelos: "NVIDIA Quadro P4000 / RTX A4000 // AMD Radeon Pro W6600 // NVIDIA GeForce RTX 3070 / 4070"
        },
        {
            software: "Oracle Primavera",
            procesador: "Intel/AMD 2.0 GHz o superior",
            ram: "8 GB (mín.) 16 GB (recom.)",
            espacio: "10 GB",
            tarjetaVideo: "No es esencial, pero puede mejorar rendimiento",
            recomendaciones: "Tarjeta básica compatible con DirectX; ayuda en gráficos de cronogramas y reportes.",
            modelos: "NVIDIA GTX 1650 / RTX 3050 // AMD Radeon RX 6500 XT"
        },
        {
            software: "ArcGIS",
            procesador: "No especificado",
            ram: "8 GB",
            espacio: "10 GB",
            tarjetaVideo: "Sí, recomendada para mejor rendimiento en 3D",
            recomendaciones: "Tarjeta compatible con DirectX 11; mejora visualización de mapas 3D y geoprocesamiento.",
            modelos: "NVIDIA GeForce RTX 3060 / 4060 // AMD Radeon RX 6600 / 7600 // NVIDIA Quadro T1000 / RTX A2000"
        },
        {
            software: "ISTRAM",
            procesador: "Intel i5 o superior",
            ram: "8 GB (mín.) 16 GB (recom.)",
            espacio: "10 GB",
            tarjetaVideo: "Sí, recomendada para modelado eficiente",
            recomendaciones: "NVIDIA Quadro o AMD Radeon Pro; optimiza diseño y renderizado de infraestructuras.",
            modelos: "NVIDIA Quadro P2200 / RTX A2000 // AMD Radeon Pro W6600 / W7600 // NVIDIA RTX 3060 / 4060"
        }
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            aria-labelledby="modal-recomendacion-software-title"
        >
            <DialogTitle id="modal-recomendacion-software-title">
                <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                    Recomendación por Software
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="tabla de recomendaciones de software">
                        <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>Software</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>Procesador</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>RAM mínima instalada</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>Espacio en Disco</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>¿Requiere Tarjeta de Video?</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>Recomendaciones y Motivo</TableCell>
                                <TableCell style={{ fontWeight: 'bold', border: '1px solid #ddd' }}>Modelos de Tarjetas de video</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {softwareData.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell style={{ border: '1px solid #ddd', backgroundColor: row.software === 'Adobe Reader' || row.software === 'SAP2000' || row.software === 'ArcGIS' ? '#8b4513' : '#2c3e50', color: 'white', fontWeight: 'bold' }}>
                                        {row.software}
                                    </TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.procesador}</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.ram}</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.espacio}</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.tarjetaVideo}</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.recomendaciones}</TableCell>
                                    <TableCell style={{ border: '1px solid #ddd' }}>{row.modelos}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalRecomendacionSoftware;